import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status, statusCode } from "../../common/constants";
import { verifyEmailAddressUrl } from "../../config";
import { RootState } from "../../store";
import api from '../../api';

interface IAdminDetails {
  name: string;
  email: string;
}

interface IInitialState {
  adminDetails: IAdminDetails;
  status: string;
  error: string | null;
}

const initialState: IInitialState = {
  adminDetails: null,
  status: Status.IDLE,
  error: null,
};

export const verifyToken: any = createAsyncThunk('verifyToken', async (verificationToken: string, { rejectWithValue }) => {
    try {
      
    const response = await api.get(verifyEmailAddressUrl + `?token=${verificationToken}`);

      if (response.status === statusCode.ok) { 
        return response.data;
      } else {
        throw new Error('Token verification failed');
      }

    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  });


const verifyTokenSlice = createSlice({
  name: "verifyToken",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(verifyToken.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(verifyToken.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.adminDetails = action.payload;
      })
      .addCase(verifyToken.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message;
      });
  },
});

export const selector = (state: RootState) => state.verifyTokenApi;

export default verifyTokenSlice.reducer;
